<template>
  <div class="contain">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>{{ breadcrumb.sceneName }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ breadcrumb.sceneTypeName }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ breadcrumb.craftName }}</el-breadcrumb-item>
        <el-breadcrumb-item>{{ breadcrumb.machineName }}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="filter">
      <div class="rf line">
        <div class="left">产品：</div>
        <div class="rfw right">
          <p
            class="cate"
            :class="{ on: cateOnId == cate.poolId }"
            v-for="(cate, cateI) in categorys"
            :key="cateI"
            @click="toChangeCate(cate.poolId)"
          >
            <span>{{ cate.poolName }}</span>
          </p>
        </div>
      </div>
      <div class="rf line">
        <div class="left">品牌：</div>
        <div class="rfw right">
          <p
            class="cate"
            :class="{ on: brandOnId == brand.brandId }"
            v-for="(brand, brandI) in brands"
            :key="brandI"
            @click="toChangeBrand(brand.brandId)"
          >
            <span>{{ brand.name }}</span>
          </p>
        </div>
      </div>
    </div>
    <div class="rfw products">
      <div class="good-item" v-for="(product, index) in products" :key="index">
        <img
          :src="product.fileUrl"
          class="cursor-pointer"
          v-show="product.fileUrl"
          alt=""
          width="260px"
          height="260px"
          @click="goDetail(product)"
        />
        <img
          src="~@/assets/img/bitmap.png"
          class="cursor-pointer"
          v-show="!product.fileUrl"
          alt=""
          width="260px"
          height="260px"
          @click="goDetail(product)"
        />
        <div
          class="price price_text"
          v-show="
            product.commodityType && product.commodityType.indexOf('非标') > -1
          "
        >
          待询价
        </div>
        <GoodPrice
          v-show="
            product.commodityType &&
            product.commodityType.indexOf('非标') === -1
          "
          :price="Number(product.minPrice) || 0"
        ></GoodPrice>
        <div class="multi_line_overflow good-spu-name line-break">
          {{ product.name }}
        </div>
        <div class="spu-code">{{$t('product.supplyCommodityCode')}}：{{ product.supplyCommodityCode }}</div>
      </div>
    </div>
    <div class="cf ac pagination">
      <el-pagination
        background
        :total="total"
        :page-size="listQuery.limit"
        :current-page.sync="listQuery.page"
        layout="prev, pager, next"
        @current-change="getProducts"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import GoodPrice from '@/components/good-price'
import { openOther } from '@/utils'

export default {
  components: {
    GoodPrice
  },
  data () {
    return {
      categorys: [],
      cateOnId: '',
      brands: [],
      brandOnId: '',
      products: [],
      total: 0,
      listQuery: {
        page: 1,
        limit: 20,
        brandId: ''
      },
      breadcrumb: {
        sceneName: '',
        sceneTypeName: '',
        craftName: '',
        machineName: ''
      }
    }
  },
  mounted () {
    if (this.$route.query.machineId) this.getCate()
    if (this.$route.query.poolId) {
      this.cateOnId = this.$route.query.poolId
      this.getBrands()
    }
    if (this.$route.query.brandId) {
      this.brandOnId = this.$route.query.brandId
      this.listQuery.brandId = this.$route.query.brandId
    }
    this.getProducts()

    this.getItems()
  },
  methods: {
    getItems () {
      // this.$http
      //   .get('/front/commodity-scene/manager/editSceneGetCopy/' + this.$route.query.sceneId)
      //   .then(({ data: res }) => {
      //     if (res.code === 0) this.breadcrumb.sceneName = res.data.sceneName
      //   })

      this.$http
        .get('/front/cross/commodity-user/sceneInfo/itemDetails', { params: { sceneId: this.$route.query.sceneId } })
        .then(({ data: res }) => {
          if (res.code === 0) {
            this.breadcrumb.sceneName = res.data.sceneName
            let list = res.data.itemDetails
            let machineId = this.$route.query.machineId

            list.forEach((v) => {
              let obj = v.sceneImgs.find((g) => {
                let dot = g.imgPositions ? g.imgPositions.find(
                  (dot) => dot.machineId.toString() === machineId.toString()
                ) : null
                if (dot) {
                  this.breadcrumb.craftName = dot.craftName
                  this.breadcrumb.machineName = dot.machineName
                  return true
                } else {
                  return false
                }
              })
              if (obj) this.breadcrumb.sceneTypeName = v.sceneTypeName
            })
          }
        })
    },
    // 跳转详情页
    goDetail (goods) {
      openOther(`goodDetail?spuId=${goods.spuId}&skuId=`)
    },
    toChangeBrand (brandId) {
      this.brandOnId = brandId
      this.listQuery.brandId = brandId
      this.listQuery.page = 1

      this.getProducts()
    },
    toChangeCate (poolId) {
      this.cateOnId = poolId
      this.brandOnId = ''
      this.listQuery.brandId = ''
      this.listQuery.page = 1

      this.getBrands()
      this.getProducts()
    },
    getProducts () {
      this.$http
        .post(
          `/front/cross/commodity-user/scenePools/${this.cateOnId}/spuList`,
          { ...this.listQuery }
        )
        .then(({ data: res }) => {
          if (res.data) {
            this.total = res.data.count
            this.products = res.data.dataList
          }
        })
    },
    getBrands () {
      this.$http
        .get(`/front/cross/commodity-user/scenePools/${this.cateOnId}/brands`)
        .then(({ data: res }) => {
          this.brands = res.data.brands
        })
    },
    getCate () {
      this.$http
        .get(
          `/front/cross/commodity-user/scenePools?machineId=${this.$route.query.machineId}`
        )
        .then(({ data: res }) => {
          this.categorys = res.data.scenePools
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.contain {
  padding-top: 26px;
  margin: 0 auto;
  width: 1190px;
  .breadcrumb {
    margin-bottom: 16px;
  }
  .filter {
    margin-bottom: 20px;
    .line {
      font-size: 12px;
      border-top: 1px solid #dedede;
      .left {
        padding-left: 10px;
        background: #f2f2f2;
        color: #333;
        overflow: hidden;
        width: 150px;
        line-height: 30px;
        flex-shrink: 0;
      }
      .right {
        background-color: #fff;
        padding: 5px 10px 0;
        width: 100%;
        .cate {
          margin: 0 10px 5px 0;
          span {
            padding: 0 6px;
            line-height: 18px;
            border: 1px solid #fff;
            display: block;
            cursor: pointer;
            -webkit-user-select: none;
          }
          &.on {
            span {
              border-color: #3d8bd4;
              background-color: #3d8bd4;
              color: #fff;
            }
          }
        }
      }
    }
  }
  .products {
    background-color: #fff;
    .good-item {
      margin-top: 3px;
      background: #fff;
      height: 380px;
      padding: 20px 10px;
      width: 25%;
      &:hover {
        -webkit-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
        -moz-box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px;
        z-index: 3;
      }
      .price_text {
        font-size: 20px;
      }
      /deep/ .price {
        margin-top: 10px;
        color: #e64c3a;
        font-weight: bold;
        .price-int {
          font-size: 20px;
        }
        .price-point {
          font-size: 10px;
        }
        a {
          color: #e64c3a;
        }
      }
      .good-spu-name {
        height: 34px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        line-height: 17px;
      }
      .spu-code {
        margin-top: 8px;
        font-size: 12px;
        font-weight: 400;
        color: #999999;
        line-height: 17px;
      }
      img {
        object-fit: contain;
      }
    }
  }
  .pagination {
    background-color: #fff;
    overflow: hidden;
    padding: 20px 0 20px 0;
  }
}
</style>
